import "rxjs/add/operator/map";
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, ActionSheetController } from 'ionic-angular';
import { FirebaseListObservable } from 'angularfire2';
import { Validators, FormBuilder } from '@angular/forms';
import { NotesData } from '../../providers/notes';
import { StorageFb } from '../../providers/storage';
import { Translate } from '../../providers/translate';
import { EventNotePage } from '../event-note/event-note';

@Component({
  selector: 'page-event-notes',
  templateUrl: 'event-notes.html'
})
export class EventNotesPage {

	/**
	 * Notes page
	 * @description: todo description
	 * @author: jcardona@ideabti.com
	 * @copyright: All rights reserved to Rebus Technology SAS - Nit: 900957687-1
	 *
	 * @param navCtrl
	 * @param params
	 * @param formBuilder
	 * @param notes
	 * @param loading
	 * @param toastCtrl
	 * @param actionSheetCtrl
	 * @param st
	 */

	obs1: any;
	event: any;
	client: any;
	notesList: FirebaseListObservable<any[]>;
	numNotes: any;
	noteForm: any;
	dataNote: any;
	imgTmp: any;
	textTranslate: any;

  constructor(public navCtrl: NavController, public params: NavParams, private formBuilder: FormBuilder, public notes: NotesData, public loading: LoadingController, public toastCtrl: ToastController, public actionSheetCtrl: ActionSheetController, public st: StorageFb, translate: Translate) {
		translate.translateGroup(['Cargando imagen', 'Nota creada correctamente', 'Guardando'])
    .then(result => {
      this.textTranslate = result;
    });

		this.event = this.params.get('event');
		this.client = this.params.get('client');

		this.obs1 = this.notes.getListNotes(this.client, this.event.id).subscribe((data: any) => {
			if (!this.notesList) {
				this.numNotes = data.length;
				if (data.length > 0) {
					this.notesList = data.reverse() as FirebaseListObservable<any[]>;
				}
			} else {
				data.reverse().forEach((newNote: any) => {
					let isNew = true;
					this.notesList.forEach((oldNote: any) => {
						if (newNote.id == oldNote.id) {
							isNew = false;
						}
					});
					if (isNew) {
						newNote.cssNew = true;
						let tmp = Object.assign([], this.notesList);
						tmp.unshift(newNote);

						this.notesList = tmp as FirebaseListObservable<any[]>;
					}
				});
			}
		});

		this.dataNote = {
			text: '',
			attachment: ''
		};

    this.noteForm = this.formBuilder.group({
      text: ['', Validators.required],
      attachment: ['']
    });
  }

	create() {
		if (this.noteForm.valid) {
			// Search image upload
			if (this.imgTmp) {
				let loader = this.loading.create({
					content: this.textTranslate["Cargando imagen"]
				});
				loader.present();
				setTimeout(() => {
					this.st.uploadNote(this.imgTmp).then((success: any) => {
						this.dataNote.attachment = success.a.downloadURLs[0];
						this.endCreate(loader);
					});
				}, 1000)
			} else {
				this.endCreate();
			}
		}
  }

	endCreate(loader2: any = false) {
		let loader = this.loading.create({
			content: this.textTranslate["Guardando"],
			duration: 3000
		});

		loader.present();

		if (loader2) {
			loader2.dismiss();
		}

		this.notes.create(this.client, this.dataNote, this.event.id)
		.then((data) => {
			this.noteForm.reset();
			this.dataNote = {
				text: '',
				attachment: ''
			};
			this.imgTmp = null;

			let toast = this.toastCtrl.create({
				message: this.textTranslate["Nota creada correctamente"],
				dismissOnPageChange: true,
				duration: 5000
			});
			loader.dismiss();
			toast.present();
		})
		.catch(error => {
			let toast = this.toastCtrl.create({
				message: error,
				duration: 5000
			});
			loader.dismiss();
			toast.present();
		});
	}

	generateFile(fileInput) {
		this.imgTmp = null;
		this.imgTmp = fileInput.target.files[0];
	}

	view(note) {
		this.navCtrl.push(EventNotePage, {note: note, event: this.event});
	}

	share() {
	}

  // Unsubsucribe observables on exit page
  ionViewWillUnload() {
    console.log('Se elimina el observable de notas', 'obs1');
    this.obs1.unsubscribe();
  }
}
// TODO: share notes
// TODO: share note
// end file



// WEBPACK FOOTER //
// ./src/pages/event-notes/event-notes.ts